import { render, staticRenderFns } from "./ComplexDaycareList.vue?vue&type=template&id=0edfeb3c&scoped=true"
import script from "./ComplexDaycareList.vue?vue&type=script&lang=js"
export * from "./ComplexDaycareList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfeb3c",
  null
  
)

export default component.exports